'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Earth = require('./Earth');

var _Earth2 = _interopRequireDefault(_Earth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Earth2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/icons/Earth/index.js
// module id = 712
// module chunks = 11